import { surface } from "./foundation";
export const Empty = surface("div", "empty", "cyra-empty");
export const EmptyContent = surface("div", "empty-content", "flex flex-col items-center gap-2");
export const EmptyHeader = surface("div", "empty-header", "flex flex-col items-center gap-2");
export const EmptyTitle = surface("h3", "empty-title", "font-medium");
export const EmptyDescription = surface("p", "empty-description", "text-sm text-muted-foreground");
